import { render } from "./AdminViewLiquidation.vue?vue&type=template&id=165d3a1d"
import script from "./AdminViewLiquidation.vue?vue&type=script&lang=js"
export * from "./AdminViewLiquidation.vue?vue&type=script&lang=js"

import "./AdminViewLiquidation.vue?vue&type=style&index=0&id=165d3a1d&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__